import { NavLink } from "react-router-dom";
import { Button, Stack } from "@mui/material";

const DesktopNavLinks = ({ navRoutesArray }) => {
  return (
    <Stack
      sx={{ display: { xs: "none", md: "flex" } }}
      direction="row"
      spacing={2}
    >
      {navRoutesArray.map(({ route, title }) => (
        <Button
          key={route}
          sx={{ color: "primary.contrastText" }}
          component={NavLink}
          to={route}
          style={({ isActive }) =>
            isActive ? { backgroundColor: "rgba(255, 255, 255, 0.25)" } : {}
          }
        >
          {title}
        </Button>
      ))}
    </Stack>
  );
};

export default DesktopNavLinks;
